export const createPinchingAnimationMeetingUniqueKey = (
  meetingID: string,
  startTime: string | null,
  testing: boolean
) => {
  return `${meetingID}-${startTime}-testMode:${testing ? 'true' : 'false'}`;
};

export const createPinchingAnimationMasterClassUniqueKey = (masterClassID: string) => {
  return masterClassID;
};
